import React, { useCallback, useRef } from 'react';
import { CustomTitle, SimpleTitle } from '@meitu/saas-ui/es/title';
import LabelAction from '@meitu/saas-editor-ui/es/components/label-action';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import { BrushTagType } from '../config';
import SelectColor from './components/select-color';
import SelectStyle from './components/select-style';
import SelectWidth from './components/select-width';
import { customConfig } from './custom-config';
import DragPopover from './drag-popover';

const RenderCurvePopover: React.FC<{
    type: BrushTagType;
    onClose?: () => void;
    onComplete?: (type: BrushTagType) => void;
}> = React.memo(({ type, onClose, onComplete }) => {
    const { $t } = useLocaleStore();

    const onCompleteHandle = useCallback(() => {
        onComplete?.(type);
    }, []);
    const draggleRef = useRef<HTMLDivElement>(null);
    return (
        <DragPopover draggleRef={draggleRef}>
            <div ref={draggleRef} className="c-brush-collapse__popover">
                <div className="c-brush-collapse__popover-title">
                    <CustomTitle
                        leftNode={<div className="left">{$t((v) => v.collapse.brushCollapse.defineCurvePen)}</div>}
                        rightNode={
                            <div
                                className="right"
                                onClick={() => {
                                    onClose?.();
                                }}
                            >
                                <IconFont name="CrossBlack" fontSize={12} color="var(--content-system-secondary)" />
                            </div>
                        }
                    />
                </div>
                <div className="c-brush-collapse__popover-subtitle">
                    <SimpleTitle text={$t((v) => v.collapse.brushCollapse.penStyle)} fontSize={14} />
                </div>
                <div className="c-brush-collapse__popover-color">
                    <LabelAction title={$t((v) => v.panel.brushPanel.color)} align={true}>
                        <SelectColor
                            defaultVal={customConfig.curve.fill.color}
                            dataSource={customConfig.curve.fill}
                            onComplete={onCompleteHandle}
                            isGradient={true}
                        />
                    </LabelAction>
                </div>
                <SelectStyle
                    defaultDasharray={customConfig.curve.fill.dasharray}
                    defaultLinecap={customConfig.curve.fill.linecap}
                    dataSource={customConfig.curve.fill}
                    onComplete={onCompleteHandle}
                />
                <SelectWidth
                    defaultVal={customConfig.curve.fill.width}
                    dataSource={customConfig.curve.fill}
                    onComplete={onCompleteHandle}
                    maxValue={100}
                    minValue={1}
                />
                <div className="c-brush-collapse__popover-split-title">
                    <SimpleTitle text={$t((v) => v.collapse.brushCollapse.stroke)} fontSize={14} />
                </div>
                <div className="c-brush-collapse__popover-color">
                    <LabelAction title={$t((v) => v.panel.brushPanel.color)} align={true}>
                        <SelectColor
                            defaultVal={customConfig.curve.stroke.color}
                            dataSource={customConfig.curve.stroke}
                            onComplete={onCompleteHandle}
                            isGradient={true}
                        />
                    </LabelAction>
                </div>
                <SelectStyle
                    isStroke={true}
                    defaultDasharray={customConfig.curve.stroke.dasharray}
                    defaultLinecap={customConfig.curve.stroke.linecap}
                    dataSource={customConfig.curve.stroke}
                    onComplete={onCompleteHandle}
                />
                <SelectWidth
                    isStroke={true}
                    defaultVal={customConfig.curve.stroke.width}
                    dataSource={customConfig.curve.stroke}
                    onComplete={onCompleteHandle}
                />
            </div>
        </DragPopover>
    );
});

export default RenderCurvePopover;
